// extracted by mini-css-extract-plugin
export default {"header":"Activites_header__Gl6Xa","title":"Activites_title__W2ktj","text":"Activites_text__7h7Ff","pink":"Activites_pink__PEJzX"};